import getLocation from './location';

export default {
  getLocation,
};
